import 'babel-polyfill'
import { createRoot } from 'react-dom/client'

import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles'
import {
  OpenTelemetryManager,
  resourceFromAttributes,
} from '@measurement/opentelemetry-web'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load'
import { AnalyticsProvider } from '@praxis/analytics/client'
import { praxisEventManagerConfig } from './appConfig/fireflyConfig'
import { initializeFirefly } from './appConfig/initializeFirefly'
import appConfig from './appConfig'
import apiConfig from './appConfig/apiConfig'
import App from './pages/App'
import ErrorBoundary from './components/common/ErrorBoundary'
import { registerChunkErrorHandlers } from './services/chunkErrorHandlers'

import './global.scss'

const theme = createTheme()

initializeFirefly()

const isLocalhost = window.location.hostname.includes('localhost')

if (!isLocalhost) {
  OpenTelemetryManager.initialize({
    apiKey: apiConfig.apiGatewayKey,
    serviceName: 'sellerlandingui',
    resource: resourceFromAttributes({
      'deployment.environment': appConfig.env,
    }),
    attributesFn: () => ({ 'page.route': window.location.pathname }),
  })

  registerInstrumentations({
    instrumentations: [new DocumentLoadInstrumentation()],
  })

  registerChunkErrorHandlers()
}

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <ErrorBoundary page="app">
    <AnalyticsProvider config={praxisEventManagerConfig}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </StyledEngineProvider>
    </AnalyticsProvider>
  </ErrorBoundary>,
)
